import { defineMessages } from 'react-intl'

const messages = defineMessages({
  showMore: {
    id: 'global.show-more',
  },
  showLess: {
    id: 'global.show-less',
  },
})

export default messages
